import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn, Route, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth.service';

async function checkAuth(url: string): Promise<boolean | UrlTree> {
  const authService = inject(AuthService);
  const isAuth = await authService.isAuthenticatedAsync();
  if (isAuth) return true;
  authService.signIn();
  return false;
}

export const wso2Guard: CanActivateFn = (
  _next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => checkAuth(state.url);

export const wso2MatchGuard: CanMatchFn = (
  _route: Route,
  segments: UrlSegment[]
) => checkAuth('/' + segments.map(s => s.path).join('/'));
